export { default, NonIdealStateProps } from './NonIdealState';
